import CarContiner from "./CarContiner";


export default function AppAufaCar ({numberCar, setNumberCar, setDataFlightCar, DataFlightCar, data}) {

    function clickCarContiner (name, away) {
        let check = away ? DataFlightCar['ca'][0] : DataFlightCar['cr'][0];
        let dd = check === name[0] ? [] : name;
        away ? setDataFlightCar(DataFlightCar => { return({...DataFlightCar, 'ca': dd})}) : setDataFlightCar(DataFlightCar => { return({...DataFlightCar, 'cr': dd})})
    }

    return (
    <div>
        <div className="AufaMainSelect">
            <p className={numberCar === 3 ? 'AufaMainSelectSelected': null} onClick={() => setNumberCar(3)} > נסיעות פנים הלוך </p>
            <p className={numberCar === 4 ? 'AufaMainSelectSelected': null} onClick={() => setNumberCar(4)} >נסיעות פנים חזור </p>
        </div>

        {data && data['A'] && data['R'] && 
        <CarContiner 
        data={numberCar === 3 ? data['A'] : data['R']}
        onClick={(name) => numberCar === 3 ? clickCarContiner(name, true) : clickCarContiner(name, false)}
        DataFlightCar={ numberCar === 3 ? DataFlightCar['fa'] : DataFlightCar['fr'] }
        numberCar={numberCar}
        /> }
    </div>
    )
}